import { useCallback, useEffect, useState } from "react";

/**
 * Keeps a launch overlay visible until auth (or similar) is ready, then waits
 * for the rocket takeoff animation before revealing content.
 */
export function useLaunchTransition(isPending: boolean, canReveal: boolean) {
  const [launchComplete, setLaunchComplete] = useState(false);

  useEffect(() => {
    if (isPending) {
      setLaunchComplete(false);
    }
  }, [isPending]);

  const handleLaunchComplete = useCallback(() => {
    setLaunchComplete(true);
  }, []);

  const showOverlay = isPending || (canReveal && !launchComplete);
  const showContent = canReveal && launchComplete;

  return {
    showOverlay,
    showContent,
    launchReady: canReveal,
    onLaunchComplete: handleLaunchComplete,
  };
}
